(()=>{
 if(customElements.get('park-pdp-explanation'))return;
 class ParkPDPExplanation extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.dialog=this.querySelector('dialog');this.opener=this.querySelector('[data-pdp-explanation-open]');
   this.closeButton=this.querySelector('[data-pdp-explanation-close]');
   if(!this.dialog||!this.opener||!this.closeButton)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};
   this.opener.addEventListener('click',()=>{
    const current=document.querySelector('dialog[open]');
    if(current&&current!==this.dialog)return;
    if(!this.dialog.open){this.dialog.showModal();this.closeButton.focus();}
   },options);
   this.closeButton.addEventListener('click',()=>this.dialog.close(),options);
   this.dialog.addEventListener('cancel',event=>{event.preventDefault();event.stopPropagation();this.dialog.close();},options);
   this.dialog.addEventListener('close',()=>{
    const target=this.returnTarget||this.opener;
    if(target.isConnected){
     if(this.returnTarget&&!target.hasAttribute('tabindex'))target.setAttribute('tabindex','-1');
     target.focus({preventScroll:true});
     if(this.returnTarget)target.scrollIntoView({block:'start'});
    }
    this.returnTarget=null;
   },options);
   this.dialog.addEventListener('click',event=>{
    const anchor=event.target.closest('a[href^="#"]');
    if(anchor){
     let target;try{target=document.getElementById(decodeURIComponent(anchor.getAttribute('href').slice(1)));}catch(_){return;}
     if(target){event.preventDefault();event.stopPropagation();this.returnTarget=target;this.dialog.close();}
     return;
    }
    if(event.target!==this.dialog)return;
    const rect=this.dialog.getBoundingClientRect();
    if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.dialog.close();
   },options);
  }
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.controller=null;}
 }
 customElements.define('park-pdp-explanation',ParkPDPExplanation);
})();
